<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>招聘中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">我的资源</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isShowDetail && !showIsAdd && !showIsInvitation">
      <section class="searchResume">
        <div class="searchStyle">
          <span class="addStyle">
            <a-button icon="usergroup-add" @click="showIsAdd = !showIsAdd"
              >新增简历</a-button
            >
            <a-button
              style="background:#fff;color:rgba(0, 0, 0, 0.65);border:1px solid #d9d9d9"
              v-show="!showIsSearch"
              @click="showIsSearch = true"
              >显示更多</a-button
            >
            <a-button
              style="background:#fff;color:rgba(0, 0, 0, 0.65);border:1px solid #d9d9d9"
              v-show="showIsSearch"
              @click="showIsSearch = false"
              >隐藏更多</a-button
            >
          </span>
          <span v-show="showIsSearch">
            <label>项目：</label>
            <a-select
              style="min-width:160px"
              v-model="project_id"
              showSearch
              :filterOption="filterOption"
            >
              <a-select-option
                v-for="element in proList"
                :key="element.id"
                :value="element.id"
                >{{ element.project_name }}</a-select-option
              >
            </a-select>
          </span>
          <span class="areaStyle" v-show="showIsSearch">
            <label>区域：</label>
            <area-cascader
              v-if="areaLinkageIsShow"
              type="text"
              placeholder="请选择省市区"
              v-model="selectArea"
              :level="1"
              :data="pcaa"
            ></area-cascader>
          </span>
          <span v-show="showIsSearch">
            <label>年龄区间：</label>
            <a-input-number style="width:50px" v-model="age_start" :min="0" />
            <span>&nbsp;~&nbsp;</span>
            <a-input-number
              style="width:50px"
              v-model="age_end"
              :min="age_start == '' ? 0 : age_start"
            />
            <span>&nbsp;岁</span>
          </span>
          <span v-show="showIsSearch">
            <label>性格：</label>
            <a-select
              defaultValue="全部"
              v-model="character_name"
              mode="multiple"
              style="min-width:120px"
            >
              <a-select-option
                :value="item"
                v-for="item in characters"
                :key="item"
                >{{ item }}</a-select-option
              >
            </a-select>
          </span>
          <span v-show="showIsSearch">
            <label>技能：</label>
            <a-select
              defaultValue="全部"
              v-model="skill_name"
              mode="multiple"
              style="min-width:120px"
            >
              <a-select-option
                :value="item"
                v-for="item in skills"
                :key="item"
                >{{ item }}</a-select-option
              >
            </a-select>
          </span>
          <span>
            <label>关键字：</label>
            <a-input
              style="width:300px;"
              v-model="query_field"
              placeholder="请输入用户姓名/手机号码/地址／沟通记录"
            />
          </span>
          <br v-show="showIsSearch" />
          <span class="locationStyle" v-show="showIsSearch">
            <div @click="positioning = !positioning" class="point">
              <label>{{ locationMap }}</label>
              <a-icon type="caret-down" />
            </div>
            <aside class="mapStyle" v-show="positioning">
              <a-icon
                @click="positioning = false"
                class="closeIcon"
                type="close"
              />
              <div class="mapSeacrhStyle">
                <label>搜素：</label>
                <input
                  type="search"
                  v-model="address"
                  placeholder="请输入地址检索"
                />
                <a @click="getMap()">重新定位</a>
              </div>
              <ul class="tips" v-if="tipsToggle">
                <li
                  v-for="(tip, index) in tips"
                  @click="selectTips(index)"
                  v-bind:key="index"
                >
                  <p>{{ tip.name }}</p>
                  <span>{{ tip.district + tip.address }}</span>
                </li>
              </ul>
            </aside>
          </span>
          <span class="point" v-show="showIsSearch">
            <div v-if="!distance" @click="distance = !distance">
              <label>距离排序</label>
              <a-icon type="column-height" />
            </div>
            <div v-else @click="distance = !distance">
              <label style="color:#1890ff">距离排序</label>
              <a-icon type="column-height" style="color:#1890ff" />
            </div>
          </span>
          <span v-show="showIsSearch">
            <label>是否在职：</label>
            <a-radio-group v-model="on_job">
              <a-radio :value="2">是</a-radio>
              <a-radio :value="1">否</a-radio>
            </a-radio-group>
          </span>
          <span>
            <a-button @click="searchReset">重置</a-button>
            <a-button type="primary" icon="search" @click="onSearch"
              >搜索</a-button
            >
          </span>
        </div>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr v-if="!distance">
              <th v-show="addTaskIsShow">
                <a-checkbox @change="onCheckAllChange">全选</a-checkbox>
              </th>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
            <tr v-if="distance">
              <th v-show="addTaskIsShow">
                <a-checkbox @change="onCheckAllChange">全选</a-checkbox>
              </th>
              <th v-for="item in thListJL" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td v-show="addTaskIsShow" class="changeTask">
                <img
                  @click="changeTaskOnly(i)"
                  v-if="item.isChange"
                  src="../../assets/home/xuanzhong.png"
                  alt
                />
                <img
                  @click="changeTaskOnly(i)"
                  v-else
                  src="../../assets/home/weixuanzhong.png"
                  alt
                />
              </td>
              <td>
                <img
                  v-show="item.is_collection == 1"
                  class="hint"
                  src="../../assets/hint.png"
                  alt
                />
                <span>{{ item.name }}</span>
              </td>
              <td>
                {{ item.age == 0 ? "" : item.age + "岁" }}
              </td>
              <td style="max-width:15%">{{ item.address }}</td>
              <td>{{ item.phone }}</td>
              <td>
                {{ item.project_name }}
              </td>
              <td>
                <p v-show="item.on_job == 1">在职</p>
                <p v-show="item.on_job == 0">不在职</p>
              </td>
              <td style="max-width:15%">
                {{
                  item.communicate.length > 20
                    ? item.communicate.substring(0, 20) + "..."
                    : item.communicate
                }}
              </td>
              <td v-show="distance">{{ item.distance }}</td>
              <td class="operation" style="width:14%">
                <a
                  style="color:#E6A23C"
                  v-show="item.is_collection == 0"
                  @click="collectionPage(item.id)"
                  >收藏</a
                >
                <a
                  style="color:#F56C6C"
                  v-show="item.is_collection == 1"
                  @click="collectionCancelPage(item.id)"
                  >取消收藏</a
                >
                <a @click="invitePage(item.id)" v-show="item.on_job != 1"
                  >邀约</a
                >
                <a style="color:#909399" @click="detailPage(item.id)">详情</a>
              </td>
            </tr>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 地图 -->
    <div id="allmap"></div>
    <!-- 地图 end -->
    <!-- 详情 -->
    <resumeDetail v-show="isShowDetail" :detailID="detailID" />
    <!-- 详情 end -->
    <!-- 增加 -->
    <addResume v-show="showIsAdd" v-on:hideIsAddResume="hideIsAddResume" />
    <!-- 增加 end -->
    <!-- 收藏 -->
    <aside class="dialogsBox" v-show="showIsCollect">
      <div>
        <h3>收藏</h3>
        <a class="close" @click="showIsCollect = false"
          ><a-icon style="color:#666" type="close-circle"
        /></a>
        <ul>
          <li><p>请评测简历等级,确认后加入收藏列表</p></li>
          <li>
            <a-radio-group v-model="willingness">
              <a-radio :value="1">A</a-radio>
              <a-radio :value="2">B</a-radio>
              <a-radio :value="3">C</a-radio>
              <a-radio :value="4">D</a-radio>
            </a-radio-group>
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="sureCollect">确认</a-button>
        </div>
      </div>
    </aside>
    <!-- 收藏 end -->
    <!-- 邀约 -->
    <invitation
      v-show="showIsInvitation"
      :invitationID="invitationID"
      v-on:hideInInvitation="hideInInvitation"
    />
    <!-- 邀约 end -->
  </div>
</template>
<script>
import axios from "axios";
import _ from "lodash";
import { pcaa } from "area-data";
import resumeDetail from "@/components/resume/resumeDetail"; //详情
import addResume from "@/components/resume/addResume"; //增加
import invitation from "@/components/resume/invitation"; //邀约
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "姓名",
        "年龄",
        "地址",
        "电话",
        "应聘项目",
        "状态",
        "最近沟通记录",
        "操作"
      ],
      thListJL: [
        "姓名",
        "年龄",
        "地址",
        "电话",
        "应聘项目",
        "状态",
        "最近沟通记录",
        "距离",
        "操作"
      ],
      ageList: [
        {
          label: "全部",
          value: -1
        },
        {
          label: "16岁以下",
          value: 1
        },
        {
          label: "16-20岁",
          value: 2
        },
        {
          label: "21-30岁",
          value: 3
        },
        {
          label: "31-40岁",
          value: 4
        },
        {
          label: "41-50岁",
          value: 5
        },
        {
          label: "50岁以上",
          value: 6
        },
        {
          label: "未知",
          value: 0
        }
      ],
      characters: [
        "外向",
        "老实",
        "好学",
        "热情",
        "勤奋",
        "滑头",
        "自私",
        "易怒",
        "冷漠",
        "迟钝"
      ],
      character_name: [],
      skills: [
        "配送员",
        "服务员",
        "保洁",
        "安保",
        "司机",
        "普工",
        "技工",
        "销售",
        "其他"
      ],
      skill_name: [],
      locationMap: "正在定位...",
      tips: [],
      selectTip: "",
      tipsToggle: false,
      address: "",
      selectArea: "",
      pcaa: pcaa,
      isShowDetail: false,
      detailID: "",
      query_field: "",
      ageSearch: -1,
      on_job: -1,
      work_type: -1,
      positioning: false,
      distance: false,
      longitude: "",
      latitude: "",
      checkAll: false,
      indeterminate: false,
      areaLinkageIsShow: true,
      age_start: "",
      age_end: "",
      project_id: "",
      proList: [],
      showIsSearch: false,
      addHideIsInterview: false,
      detailsVal: {},
      addTaskIsShow: false,
      addTaskSure: false,
      showIsAdd: false,
      willingness: "",
      showIsCollect: false,
      collectID: "",
      showIsInvitation: false,
      invitationID: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getPro(); //获取项目
    if (window.localStorage.getItem("locationMapSetPC") == null) {
      this.getMap();
    } else {
      this.locationMap = window.localStorage.getItem("locationMapSetPC");
      this.latitude = window.localStorage.getItem("locationMapSetlatitudePC");
      this.longitude = window.localStorage.getItem("locationMapSetlongitudePC");
    }
    this.debounce = _.debounce(() => this.search(this.address), 100);
    this.getData(); //获取列表
  },
  watch: {
    address() {
      this.debounce();
    },
    distance() {
      this.page = 1;
      this.getData();
    }
  },
  components: {
    resumeDetail,
    addResume,
    invitation
  },
  methods: {
    hideInInvitation() {
      this.showIsInvitation = false;
      this.reload();
    },
    collectionCancelPage(id) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume/cancelCollection";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        resume_id: id
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("取消收藏！");
            this.reload();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    collectionPage(id) {
      this.showIsCollect = true;
      this.collectID = id;
    },
    sureCollect() {
      if (this.willingness != "") {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.resume +
          "Resume/resumeCollection";
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          resume_id: this.collectID,
          willingness: this.willingness
        };
        axios
          .post(url, params)
          .then(res => {
            if (res.data.code == 200) {
              this.$message.success("收藏成功！");
              this.willingness = "";
              this.showIsCollect = false;
              this.reload();
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(err => {
            this.$toast.error(err);
          });
      } else {
        this.$message.error("请选择收藏等级");
      }
    },
    invitePage(id) {
      // console.log(id);
      this.showIsInvitation = true;
      this.invitationID = id;
    },
    hideIsAddResume() {
      this.showIsAdd = false;
      this.reload();
    },
    detailPage(id) {
      this.detailID = id;
      this.isShowDetail = true;
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    changeTaskOnly(i) {
      this.data[i].isChange = !this.data[i].isChange;
      this.$forceUpdate();
    },
    backHref() {
      this.isShowDetail = false;
      this.showIsAdd = false;
      this.showIsInvitation = false;
      this.reload();
    },
    getMap() {
      this.locationMap = "正在定位...";
      window.localStorage.removeItem("locationMapSetPC");
      window.localStorage.removeItem("locationMapSetlatitudePC");
      window.localStorage.removeItem("locationMapSetlongitudePC");
      // eslint-disable-next-line no-undef
      const geolocation = new BMap.Geolocation();
      var _this = this;
      geolocation.getCurrentPosition(
        function getinfo(position) {
          _this.latitude = position.latitude;
          _this.longitude = position.longitude;
          window.localStorage.setItem(
            "locationMapSetlatitudePC",
            _this.latitude
          );
          window.localStorage.setItem(
            "locationMapSetlongitudePC",
            _this.longitude
          );
          _this.getLocation(position.longitude, position.latitude);
        },
        function(e) {
          _this.locationMap = "定位失败";
        },
        { provider: "baidu" }
      );
      this.positioning = false;
    },
    getLocation(longitude, latitude) {
      // eslint-disable-next-line no-undef
      var map = new BMap.Map("allmap");
      // eslint-disable-next-line no-undef
      var point = new BMap.Point(longitude, latitude);
      map.centerAndZoom(point, 12);
      let _this = this;
      // eslint-disable-next-line no-undef
      var geoc = new BMap.Geocoder();
      var pt = point;
      geoc.getLocation(pt, function(rs) {
        var addComp = rs.addressComponents;
        // console.log(addComp);
        _this.locationMap = addComp.street + addComp.streetNumber;
        window.localStorage.setItem("locationMapSetPC", _this.locationMap);
        _this.page = 1;
        _this.getData();
      });
    },
    async search(keyword) {
      const url = "https://restapi.amap.com/v3/assistant/inputtips";
      const params = new URLSearchParams();
      params.append("keywords", keyword);
      // console.log(keyword)
      // 开发者key
      params.append("key", "c72ccd557512d20dbaff7b16a280fd33");
      params.append("output", "JSON");
      const { data } = await axios.get(`${url}?${params.toString()}`);
      // console.log(data);
      if (data.status === "1") {
        this.tips = data.tips;
        if (data.tips.length > 0 && !this.hasdata) {
          this.tipsToggle = true;
        } else {
          this.tipsToggle = false;
        }
        setTimeout(() => {
          this.hasdata = false;
        }, 500);
      }
    },
    selectTips(index) {
      // console.log(this.tips[index].location);
      if (this.tips[index].location != "") {
        window.localStorage.removeItem("locationMapSetPC");
        window.localStorage.removeItem("locationMapSetlatitudePC");
        window.localStorage.removeItem("locationMapSetlongitudePC");
        this.selectTip = this.tips[index];
        let lo = this.tips[index]["location"].split(",");
        this.address = this.tips[index]["name"];
        this.locationMap = this.tips[index]["name"];
        window.localStorage.setItem(
          "locationMapSetPC",
          this.tips[index]["name"]
        );
        window.localStorage.setItem("locationMapSetlatitudePC", lo[1]);
        window.localStorage.setItem("locationMapSetlongitudePC", lo[0]);
        this.hasdata = true;
        this.tipsToggle = false;
        this.positioning = false;
        window.location.reload();
        this.page = 1;
        this.getData();
        // this.getMap(this.selectTip.location)
        //  console.log(this.hasdata)
      } else {
        this.$message.error("请输入详细地址");
      }
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    searchReset() {
      this.areaLinkageIsShow = false;
      setTimeout(() => {
        this.areaLinkageIsShow = true;
      }, 10);
      this.on_job = -1; //
      this.work_type = -1;
      this.age_start = "";
      this.age_end = "";
      this.project_id = "";
      this.character_name = [];
      this.skill_name = [];
      this.distance = false;
      this.selectArea = "";
      this.query_field = "";
      this.character_name = [];
      this.page = 1;
      this.getData();
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.checkAll = false;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_New/myResumeList";
      let city;
      if (
        this.selectArea[0] == "上海市" ||
        this.selectArea[0] == "天津市" ||
        this.selectArea[0] == "北京市" ||
        this.selectArea[0] == "重庆市"
      ) {
        city = this.selectArea[0];
      } else {
        city = this.selectArea[1];
      }
      let params = {
        current_page: this.page,
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 10,
        query_field: this.query_field,
        longitude: this.distance ? this.longitude : "",
        latitude: this.distance ? this.latitude : "",
        province: this.selectArea == "" ? "" : this.selectArea[0],
        city: this.selectArea == "" ? "" : city,
        area: this.selectArea == "" ? "" : this.selectArea[2],
        on_job: this.on_job,
        age_start: this.age_start,
        age_end: this.age_end,
        skill_name: JSON.stringify(this.skill_name),
        character_name: JSON.stringify(this.character_name),
        project_id: this.project_id
      };
      axios
        .post(url, params)
        .then(res => {
          //   console.log(res);
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.data.forEach(element => {
              element.isChange = false;
            });
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    onCheckAllChange(e) {
      this.data.forEach((element, i) => {
        return (this.data[i].isChange = e.target.checked);
      });
      this.$forceUpdate();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.searchResume {
  padding: 14px 2% 4px;
  .searchStyle {
    padding: 14px 2%;
    > span {
      display: inline-block;
      margin-right: 30px;
      margin-bottom: 16px;
      line-height: 32px;
      > div {
        display: inline-block;
        vertical-align: top;
      }
      label {
        line-height: 32px;
      }
      > button {
        margin-left: 10px;
      }
    }
  }
}
.locationStyle {
  position: relative;
}
.mapStyle {
  position: absolute;
  background: #fff;
  left: -10px;
  top: 34px;
  z-index: 1;
  width: 77vw;
  min-height: 80vh;
  border: 1px solid #ccc;
  padding: 10px 0;
}
.closeIcon {
  position: absolute;
  right: 20px;
  top: 10px;
}
.mapSeacrhStyle {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  input {
    // background: #f2f2f2;
    border: 1px solid #ccc;
    padding: 4px 6px;
    font-size: 14px;
  }
  a {
    margin-left: 30px;
    color: -webkit-link;
  }
}
.tips {
  // background: #f1f1f1;
  margin: 0 10px 10px 50px;
  li {
    margin-bottom: 6px;
    padding: 6px;
    cursor: pointer;
    p {
      font-size: 14px;
    }
    span {
      color: #999;
      font-size: 12px;
    }
  }
  li:hover {
    background: #f2f2f2;
  }
}
.point {
  label {
    cursor: pointer;
  }
}
.addStyle {
  margin-right: 2%;
  button {
    background-color: #67c23a;
    border-color: #67c23a;
    color: #fff;
  }
  button:first-child {
    margin-left: 0 !important;
  }
}
.changeTask {
  img {
    height: 16px;
  }
}
.hint {
  height: 12px;
  display: inline-block;
  margin-right: 2px;
}
</style>
<style lang="less">
.area-select .area-selected-trigger {
  padding: 0 20px 0 12px;
  line-height: 32px;
}
</style>
